import {Component, EventEmitter, OnDestroy, Output} from '@angular/core';
import {FormGroup, FormBuilder, FormControl} from '@angular/forms';

import {SubFormComponent} from '../_subform';
import {FormHelperService} from '@services/form-helper.service';
import {MethodsProvider} from '@providers/methods/methods.provider';
import {MethodLevelsProvider} from '@providers/method-levels/method-levels.provider';

@Component({
    providers: [
        FormHelperService
    ],
    selector: 'certificate-nk',
    templateUrl: './nk.component.html',
    styleUrls: ['./nk.component.scss']
})
export class NkCertificateComponent extends SubFormComponent implements OnDestroy {

    @Output() remove = new EventEmitter<any>();

    public formGroupTemplate = this._fb.group({
        id: [''],
        number: [''],
        date_issue: [''],
        methods: this._fb.array([this.createMethod()]),
        file: this._fb.group({
            file_id: [''],
            file_url: ['']
        }),
        file_back: this._fb.group({
            file_id: [''],
            file_url: ['']
        })
    });

    /**
     * Методы для выбора
     * @type {Array}
     */
    public methods = [];

    constructor(public methodsProviderService: MethodsProvider,
                public methodLevelList: MethodLevelsProvider,
                public formHelper: FormHelperService,
                private _fb: FormBuilder) {
        super();
    }

    afterInit() {
        this.subs.push(
            this.methodsProviderService.data$.subscribe(value => {
                if (!value || !value.all) {
                    return;
                }
                this.methods = value.all.map(method => {
                    return {
                        id: method.id,
                        title: `${+method.lvl > 2 ? '- ' : ''}${method.title}`
                    };
                });
            })
        );
    }

    createMethod(): FormGroup {
        /*
        * При добавлении нового метода в удостоверение, если в нем уже есть запись с методом, то в качестве выбранных
        * по-умолчанию объектов устанавливаем объекты первого метода.
        * */
        const objectsDefaultValue = this.form && this.form.get('methods').value.length
            ? this.form.get('methods').value[0].objects_string : '';

        return this._fb.group({
            method_id: [''],
            level: [''],
            objects_string: [objectsDefaultValue],
            is_renewal: [false],
            expiration_date: ['']
        });
    }

    /*
    * Устанавливаем значение объектов из модалки.
    * Геренируем строку с перечислением объектов: 2, 3, 5.1, 6
    * */
    setObjectsToMethod(objectsControl: FormControl, objects: any[]) {
        const objectsString = objects.reduce((value, item) => {
            return value += `${item.number}, `;
        }, '').slice(0, -2);
        objectsControl.markAsDirty();
        objectsControl.patchValue(objectsString);
    }

    /*
    * Очищаем значения объектов для метода
    * */
    clearObjectsForMethod(objectsControl: FormControl) {
        objectsControl.patchValue('');
    }

    onRemoveClick() {
        this.remove.emit();
    }
}
